import type { ReactNode } from 'react';
import { useSilobagListContext } from '../../context';
import type { SilobagListLogicState } from '../../hook/use-silobag-list-logic-state';
import { SilobagHeader } from './silobag-header';
import { SilosProHeader } from './silospro-header';

type ViewComponentLink = Record<SilobagListLogicState['view'], ReactNode>;

export function Header() {
  const {
    state: { current },
  } = useSilobagListContext();

  const HEADER_BY_VIEW = {
    silospro: <SilosProHeader />,
    silobag: <SilobagHeader />,
  } as const satisfies ViewComponentLink;

  return HEADER_BY_VIEW[current.view] ?? null;
}
